import * as React from "react";
import PropTypes from "prop-types";
import { DialogContent } from "@material-ui/core";
import PaymentSection from "./PaymentSection";
import RememberMeSection from "./RememberMeSection";
import AddressSection from "./AddressSection";

const Sections = React.memo(function Sections({
  state,
  dispatch,
  showBillingAddress,
  showShippingAddress,
}) {
  const setUseSavedCard = React.useCallback(
    (newValue) => {
      dispatch({ type: "useSavedCard", payload: newValue });
    },
    [dispatch],
  );

  const setRememberMe = React.useCallback(
    (newValue) => {
      dispatch({ type: "rememberMe", payload: newValue });
    },
    [dispatch],
  );

  const setBillingAddress = (key) => (evt) => {
    dispatch({
      type: "billingAddress",
      payload: { ...state.billingAddress, [key]: evt.target.value },
    });
  };

  const setShippingAddress = (key) => (evt) => {
    dispatch({
      type: "shippingAddress",
      payload: { ...state.shippingAddress, [key]: evt.target.value },
    });
  };

  return (
    <DialogContent>
      <PaymentSection
        title="Payment"
        subtitle="All transactions are encrypted and secure."
        purchaseDetails={state.purchaseDetails}
        savedPaymentDetails={state.savedPaymentDetails}
        useSavedCard={state.useSavedCard}
        setUseSavedCard={setUseSavedCard}
      />

      {showBillingAddress && (
        <AddressSection
          title="Billing Address"
          subtitle="Set your billing address"
          defaultAddress={state.defaultAddress}
          address={state.billingAddress}
          setAddress={setBillingAddress}
        />
      )}

      {showShippingAddress && (
        <AddressSection
          title="Shipping Address"
          subtitle="Set your shipping address"
          defaultAddress={state.defaultAddress}
          address={state.shippingAddress}
          setAddress={setShippingAddress}
        />
      )}

      {(showBillingAddress || showShippingAddress) && (
        <RememberMeSection
          setRememberMe={setRememberMe}
          rememberMe={state.rememberMe}
        />
      )}
    </DialogContent>
  );
});

Sections.propTypes = {
  state: PropTypes.object,
  dispatch: PropTypes.func,
  showShippingAddress: PropTypes.bool,
  showBillingAddress: PropTypes.bool,
};

export default Sections;
